import { render, staticRenderFns } from "./ListLimitations.vue?vue&type=template&id=a003d2fc&scoped=true&"
import script from "./ListLimitations.vue?vue&type=script&lang=js&"
export * from "./ListLimitations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a003d2fc",
  null
  
)

export default component.exports